var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoveBothDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M3 20h24v1H3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.547 36.132 7.3 29.973a1.003 1.003 0 0 1 0-1.433 1.04 1.04 0 0 1 1.453 0L15 34.7l6.246-6.159c.372-.367.96-.394 1.363-.079l.09.08a1.003 1.003 0 0 1 0 1.432l-6.247 6.158.001.001L15 37.565z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#AAA",
  fillRule: "evenodd",
  d: "m16.453 4.868 6.246 6.159a1.003 1.003 0 0 1 0 1.433 1.04 1.04 0 0 1-1.453 0L15 6.3 8.754 12.46c-.372.367-.96.394-1.363.079l-.09-.08a1.003 1.003 0 0 1 0-1.432l6.247-6.158-.001-.001L15 3.435z",
  clipRule: "evenodd"
})));
export { SvgMoveBothDown as ReactComponent };